$(function () {
  /** ============================
   *  タブスクロール調整
   * ============================ */

  function adjustTabScroll() {
    if (window.innerWidth <= 991) {
      const currentTab = document.querySelector(".p-TabMenu__btnList .current");
      const tabContainer = document.querySelector(".p-TabMenu__btnList");
      if (currentTab && tabContainer) {
        const tabRect = currentTab.getBoundingClientRect();
        const containerRect = tabContainer.getBoundingClientRect();
        tabContainer.scrollLeft += tabRect.left - containerRect.left - (containerRect.width / 2 - tabRect.width / 2);
      }
    }
  }
  adjustTabScroll();

  /**
   * wovn 翻訳するとwidthが変わるので遅延対応
   */
  function setupTabScroll() {
    if (window.WOVN && WOVN.io && WOVN.io.isApiReady()) {
      adjustTabScroll();
    } else {
      window.addEventListener("wovnApiReady", function () {
        const newLang = WOVN.io.getCurrentLang().code;
        if (newLang === "ja") {
          adjustTabScroll(); // 翻訳なし
        } else {
          window.addEventListener("wovnLangChanged", function () {
            requestAnimationFrame(() => {
              setTimeout(adjustTabScroll, 300);
            });
          });
        }
      });
    }
  }

  setupTabScroll();
});
